import React from 'react';

import {
  FormControl,
  TextField,
} from '@mui/material';
import { Controller } from 'react-hook-form';

/**
 * プロパティ
 */
export type Props = {
  /** 名前 */
  name: string,
  /** ラベル */
  label: string,
  /** ルール */
  rules: any,
  /** エラー */
  errors: any,
  /** コントロール */
  control: any,
}

const DateFieldComp: React.FC<Props> = ({
  control,
  rules,
  name,
  label,
  errors,
}) => (
  <div style={{ margin: '10px 0' }}>
    <FormControl variant="outlined" fullWidth>
      <Controller
        render={
          ({ field }) => (
            <TextField
              label={label}
              variant="outlined"
              value={field.value}
              onChange={field.onChange}
              type="date"
              fullWidth
              error={errors[name] !== undefined}
              helperText={errors[name] && errors[name].message}
            />
          )
        }
        name={name}
        control={control}
        rules={rules}
      />
    </FormControl>
  </div>
);

export default DateFieldComp;
